import { ExclamationBrown } from '@icons';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface MissingDocumentIconProps {}

const MissingDocumentIcon: React.FC<MissingDocumentIconProps> = () => {
	return (
		<OverlayTrigger placement="top" overlay={<Tooltip>Documento mancante</Tooltip>}>
			<ExclamationBrown fill="#995C00" className="me-2" />
		</OverlayTrigger>
	);
};

export default MissingDocumentIcon;
